module.exports = __webpack_public_path__ + "img/bg_personalcenter2.0c142372.jpg";